
import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';



const PaymentCreate = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchmaxbillno();
        fetchPaymentmethodTypes();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [recordCount, setRecordCount] = useState(0);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BillDate: '',
        BillNo: 0,
        MasterId: '',
        CreatedBy: userId,
        isSubmit: false,

    });
    const [showBankField, setShowBankField] = useState(true);
    const fetchmaxbillno = () => {
        fetchData('PaymentApi', `/MaxBillno/${branchId}/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                setFormData(prevData => ({
                    ...prevData,
                    BillNo: data.BillNumber,
                    BillDate: formattedDate,
                    FinYear: data.FinYear,
                    BranchId: branchId,
                    CompanyId: companyId,
                }));

            })
            .catch((error) => {
                console.error('Error fetching Max Billno', error);
            });


    };

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);

        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        console.log(selectedOption);

        if (selectedOption) {
            fetchData('PaymentApi', `/PartyPaymentBill/${selectedOption.value}/${companyId}`, token)
                .then((response) => {
                    if (response.responseCode === '1111') {

                        const updatedInvoicedetailsSorted = response.response_data;

                        const totalSaleAmount = updatedInvoicedetailsSorted.reduce((total, invdetail) => {
                            return total + invdetail.PendingAmount;
                        }, 0);

                        // Update formData with total SaleAmount
                        setFormData((prevData) => ({
                            ...prevData,
                            TotalBalAmt: totalSaleAmount,
                        }));

                        setInvoicedeatils(updatedInvoicedetailsSorted);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching invoice details:', error);
                });
        }

    };

    useEffect(() => {
        fetchCustomerData();
    }, []);

    //FOR GET Customer  Details FROM API
    const fetchCustomerData = () => {
        fetchData('PaymentApi', `/Party/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)                
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.Id,
                }));
                setCustomerOptions(options);

            })
            .catch((error) => {
                console.error('Error fetching customer data:', error);
            });
    };



    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        if (name === 'Amount') {
            let newAmount = parseFloat(value);
            if (isNaN(newAmount)) {
                newAmount = 0;
            }

            if (formData.TotalBalAmt != 0) {
                // Ensure the entered amount does not exceed formData.TotalBalAmt
                const restrictedAmount = Math.min(newAmount, formData.TotalBalAmt);

                // Update formData with the restricted amount value
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: type === 'checkbox' ? checked : restrictedAmount,
                }));

                // Initialize remaining balance to the restricted amount
                let remainingBalance = restrictedAmount;

                // Loop through each row in invoicedeatils
                const updatedInvoicedeatils = invoicedeatils.map((invdetail) => {
                    // Calculate the amount for this row (minimum of SaleAmount and remaining balance)
                    const amountForThisRow = Math.min(invdetail.PendingAmount, remainingBalance);

                    // Update the remaining balance
                    remainingBalance -= amountForThisRow;

                    // Ensure invdetail.Amount does not exceed invdetail.SaleAmount
                    const updatedAmount = Math.min(amountForThisRow, invdetail.PendingAmount);

                    // Calculate the balance amount for this row (ensure it's not negative)
                    const balanceForThisRow = Math.max(invdetail.PendingAmount - updatedAmount, 0);

                    // Return the updated row
                    return {
                        ...invdetail,
                        Amount: parseFloat(updatedAmount),
                        BalanceAmount: parseFloat(balanceForThisRow),
                    };
                });

                // Update invoicedeatils with the updated values
                setInvoicedeatils(updatedInvoicedeatils);
            }
            else {
                let newAmt = parseFloat(value);
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: type === 'checkbox' ? checked : newAmt,
                }));
            }

        } else if (name === 'PaymentType') {
            // Handle changes for the Payment Type radio buttons
            const newPaymentType = value;

            setSelectedPaymentType(newPaymentType);

            setFormData((prevData) => ({
                ...prevData,
                PaymentType: newPaymentType,
            }));
        }
        else {
            // For other form fields, update formData directly
            setFormData((prevData) => ({
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
            }));
        }
    };

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };


    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            CompanyId: companyId,
            BillDate: formattedDate,
            ChequeDate: formattedDate,
            // PaymentType: selectedPaymentmethodType.value,
            PaymentType: 1,
        }));
    }, []);


    const [selectedPaymentType, setSelectedPaymentType] = useState("1");

    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            // Assuming it's a direct value passed
            name = inputType; // Use the provided inputType directly as the name
            value = e;
        }

        // Update the invoicedeatils array with the edited value
        const updatedInvoicedeatils = invoicedeatils.map((invdetail, idx) => {
            if (idx === index) {
                const updatedAmount = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
                const saleAmount = parseFloat(invdetail.PendingAmount);

                // If the updated amount is greater than the sale amount, update Amount and BalanceAmount
                if (parseFloat(updatedAmount) < parseFloat(saleAmount)) {
                    const balanceAmount = (saleAmount - updatedAmount).toFixed(2);
                    return {
                        ...invdetail,
                        Amount: parseFloat(updatedAmount),
                        BalanceAmount: parseFloat(balanceAmount),
                    };
                } else {
                    // Otherwise, update Amount and reset BalanceAmount to 0
                    return {
                        ...invdetail,
                        Amount: parseFloat(saleAmount),
                        BalanceAmount: 0,
                    };
                }
            } else {
                // If it's not the updated row, return the original invdetail
                return invdetail;
            }
        });

        // Recalculate the total billed amount and quantity for the form
        let totalBilledAmount = 0;

        updatedInvoicedeatils.forEach((invdetail) => {
            // Ensure the Amount is valid, otherwise default to 0
            const amount = parseFloat(invdetail.Amount) || 0;
            totalBilledAmount += amount;

        });

        // Update the formData state with the calculated total billed amount and total quantity
        setFormData((prevState) => ({
            ...prevState,
            Amount: totalBilledAmount.toFixed(2),
        }));


        // Update invoicedeatils state with the updated invoicedeatils array
        setInvoicedeatils(updatedInvoicedeatils);
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = invoicedeatils.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    //customer Payment Method 
    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");


    const fetchPaymentmethodTypes = async () => {
        try {
            const response = await fetchData('PaymentApi', `/PaymentModes/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setPaymentmethodOptions(options);
                setShowBankField(true);
            }
        } catch (error) {
            console.error('Error fetching PaymentModes:', error);
        }
    };

    const handlePaymentTypeChange = (selectedOption) => {
        setSelectedPaymentmethodType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            PaymentType: selectedOption.value,
        }));
        if (["Cheque", "RTGS", "NEFT", "UPI"].includes(selectedOption.label)) {
            setShowBankField(false);
        } else {
            setShowBankField(true);
        }
    };

    useEffect(() => {
        fetchPaymentmethodTypes();
    }, []);


    //Bank
    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");

    const fetchBanks = async () => {
        try {
            const response = await fetchData('PaymentApi', `/Banks/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Bank:', error);
        }
    };

    const handleBankChange = (selectedOption) => {
        setSelectedBank(selectedOption);
    };

    useEffect(() => {
        fetchBanks();
    }, []);


    const submitData = async (e) => {
        setIsLoading(true);

        if (!formData.MasterId || formData.MasterId === 0) {
            setErrorMessage('Supplier is required!');
            setIsLoading(false);
            return;
        }

        if (!formData.Amount || formData.Amount === 0) {
            setErrorMessage('Amount must be Greater than 0!');
            setIsLoading(false);
            return;
        }

        // Validation for non-cash payment types
        if (selectedPaymentmethodType && selectedPaymentmethodType.label !== 'Cash') {
            if (!formData.ChequeNumber) {
                setErrorMessage('Reference No is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!formData.ChequeDate) {
                setErrorMessage('Reference Date is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!formData.chequeDetails) {
                setErrorMessage('Reference Details are required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!selectedBank) {
                setErrorMessage('Bank selection is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
        }

        const updatedFormData = {
            ...formData,
            CreatedBy: userId,
            BankId: selectedBank ? selectedBank.value : null,
        };

        const createData = {
            PaymentAndReceipt: updatedFormData,
            PaymentAndReceiptPurchaseCollection: invoicedeatils,
        };

        console.log('Submitting data:', createData);

        try {
            const response = await postData('PaymentApi', createData, token);
            setSuccessMessage('Payment Created successfully!');
            setErrorMessage('');

            history.push('/PaymentIndex');
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);

        } catch (error) {
            console.error('Payment Create error:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
                console.error('Response headers:', error.response.headers);
            } else if (error.request) {
                console.error('Request was made but no response received:', error.request);
            } else {
                console.error('Error in setting up the request:', error.message);
            }
            setErrorMessage('Failed to create Payment. Please try again.');
            setIsLoading(false);
        }
    };



    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-10px' }}>

            <div className="flex flex-wrap justify-between items-center mb-4">
                <h6
                    className="uppercase tracking-wide text-black font-serif flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        marginTop: '10px',
                    }}
                >
                    Payment Create (Against Purchase)
                </h6>


                <div className="flex mt-8 w-full sm:w-auto">

                    <Button
                        style={{
                            background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                            color: 'black',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            //marginLeft: '5px',
                            marginLeft: '15px',

                        }}
                        onClick={submitData}
                        disabled={isLoading}
                    >
                        <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Save</b>}
                    </Button>

                    <Button
                        color="error"
                        component={Link}
                        to={{
                            pathname: "/PaymentIndex",
                            state: { from: "/PaymentCreate" },
                        }}
                        onClick={() => {
                            localStorage.setItem('shouldReload', 'true');
                        }}
                        className="linkcolor"
                        style={{
                            background: 'linear-gradient(to right, #FFAAAA,#FFAAAA)',
                            color: 'black',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',

                        }}
                    >
                        <CloseIcon style={{ color: '#A91D3A', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Cancel</b>
                    </Button>
                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>

                <div className="w-full pr-4" style={{ marginTop: '-0.21%' }}>
                    <div className="w-full mb-2 flex">

                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                Supplier Name
                            </label>

                            <Select
                                value={selectedCustomer}
                                onChange={handleCustomerSelect}
                                options={customerOptions}
                                placeholder="Select Supplier"
                                isSearchable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '35px',
                                        minHeight: '35px',
                                        fontSize: '14px',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                Bill Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.BillDate)}
                                onChange={handleChange}
                                type="date"
                                name='BillDate'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Bill Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.BillNo || ''}/${formData.FinYear || ''}`}
                                onChange={handleChange}
                                type="text"
                                placeholder="Bill Number"
                                name='BillNo'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                Payment Mode
                            </label>

                            <Select
                                value={selectedPaymentmethodType || { value: 'cash', label: 'Cash' }}  // Default to "Cash" if not selected
                                onChange={handlePaymentTypeChange}
                                options={paymentmethodOptions}
                                placeholder="PaymentOption"
                                isSearchable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '35px',
                                        minHeight: '35px',
                                        fontSize: '14px',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Amount || ''}
                                onChange={handleChange}
                                type="number"
                                placeholder="Amount"
                                name='Amount'
                                style={{ textAlign: 'right', fontWeight: 'bold', height: '35px' }}
                            />
                        </div>

                    </div>
                    <div className="w-full mb-2 flex">

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Bank' : 'Bank'}
                                <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedBank || { value: '', label: 'Select Bank' }}
                                onChange={handleBankChange}
                                options={bankOptions}
                                placeholder="Select Bank"
                                isSearchable
                                isDisabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '35px',
                                        minHeight: '35px',
                                        fontSize: '14px',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                    }),
                                }}
                            />
                        </div>

                        <div className="w-1/6 mr-2">

                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque No' : 'Reference No'}
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.ChequeNumber}
                                type="text"
                                placeholder=""
                                name="ChequeNumber"
                                onChange={handleChange}
                                style={{ height: '35px' }}
                                disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                            />
                        </div>



                        <div className="w-1/8 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Date' : 'Reference Date'}
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.ChequeDate)}
                                type="date"
                                placeholder=""
                                name="ChequeDate"
                                onChange={handleChange}
                                style={{ height: '35px' }}
                                disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                            />
                        </div>


                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Details' : 'Reference Details'}
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.chequeDetails}
                                type="text"
                                placeholder=""
                                name="chequeDetails"
                                onChange={handleChange}
                                style={{ height: '35px' }}
                                disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                            />
                        </div>



                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Remarks"
                                name="Remarks"
                                value={formData.Remarks}
                                onChange={handleChange}
                                style={{ height: '35px', width: '100%' }}
                            />
                        </div>

                    </div>
                </div>
            </div>

            <div className="w-full flex flex-wrap" style={{ backgroundColor: '#c9dedb', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>

                <div className="w-full mb-2" style={{ backgroundColor: '#c9dedb', marginTop: '-0.15%', overflow: 'auto' }}>
                    <table
                        className="min-w-full bg-white shadow-md rounded-lg overflow-hidden"
                        style={{ borderCollapse: 'collapse' }}
                    >
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>SL.No</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>BILL DETAILS</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>AMOUNT</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>PENDING AMOUNT</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>PAID AMOUNT</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>BALANCE</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredData.map((item, index) => {


                                return (
                                    <tr key={index} className="border-b"
                                        style={{
                                            backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                            borderBottom: '1px solid #E0E0E0',
                                            transition: 'transform 0.2s ease-in-out',
                                            cursor: 'pointer',
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    >
                                        <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '1px', textAlign: 'center', width: '65px' }}>
                                            {index + 1}
                                        </td>
                                        <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '250px' }}>{item.PurchaseDescription}</td>

                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                type="number"
                                                value={item.PurchaseAmount}
                                                className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FBF6E9', textAlign: 'right' }}
                                                min="0"
                                                aria-label={`Order quantity for item ${item.Id}`}
                                                name="PurchaseAmount"
                                                readOnly
                                            />
                                        </td>
                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                value={item.PendingAmount || 0}
                                                className="w-full px-1 py-1 border rounded-md"
                                                style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#CBE4DE', textAlign: 'right' }}
                                                type="number"
                                                name="PendingAmount"
                                                readOnly
                                            />
                                        </td>
                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                value={item.Amount || 0}
                                                className="w-full px-1 py-1 border rounded-md"
                                                style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                name="Amount"
                                                onChange={(e) => handleCalculation(e, index, 'Amount')}
                                                readOnly
                                            />
                                        </td>
                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                value={item.BalanceAmount || 0}
                                                className="w-full px-1 py-1 border rounded-md"
                                                style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#F6D6D6', textAlign: 'right' }}
                                                type="number"
                                                name="BalanceAmount"
                                                readOnly
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

        </div >
    );
}

export default PaymentCreate;
